import {Component, Input} from '@angular/core';

/**
 * the Header for a Detail Cell
 */
@Component({
  selector: 'ap-crop-rotation-detail-header-big',
  templateUrl: './detail-header.component.html'
})
export class DetailHeaderComponent {
  /**
   * is this Cell stands for the current Campaign Year then highlight it
   */
  @Input() isHighlighted = false;
  /**
   * the Label for the Main Crop
   */
  @Input() mainCropLabel = '';

  /**
   * the Label for Straw Harvested
   */
  @Input() mainCropStrawHarvestedLabel = '';
  /**
   * the Label for the Main Crop Yield
   */
  @Input() mainCropYieldLabel = '';
  /**
   * the Label for the Second Crop
   */
  @Input() secondCropLabel = '';
  /**
   * the Label for the Second Crop Yield
   */
  @Input() secondCropYieldLabel = '';
}
